<template>
  <v-container>
    <h2 class="text-center">Acerca del Sistema</h2>

    <v-row justify="center">
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-img
              src="/path/to/another-image.jpg"
              alt="Otra tarjeta"
              height="200"
          ></v-img>
          <v-card-title class="text-center">tarjeta</v-card-title>
          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer mattis vehicula lacus, nec sollicitudin elit vestibulum vel. Curabitur in velit a ex consectetur lacinia.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-img
              src="/path/to/another-image.jpg"
              alt="Otra tarjeta"
              height="200"
          ></v-img>
          <v-card-title class="text-center">tarjeta</v-card-title>
          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer mattis vehicula lacus, nec sollicitudin elit vestibulum vel. Curabitur in velit a ex consectetur lacinia.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-img
              src="/path/to/development-image.jpg"
              alt="Desarrollo"
              height="200"
          ></v-img>
          <v-card-title class="text-center">tarjeta</v-card-title>
          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer mattis vehicula lacus, nec sollicitudin elit vestibulum vel. Curabitur in velit a ex consectetur lacinia.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-img
              src="/path/to/project-manager-image.jpg"
              alt="Jefe de Proyecto"
              height="200"
          ></v-img>
          <v-card-title class="text-center">tarjeta</v-card-title>
          <v-card-text>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer mattis vehicula lacus, nec sollicitudin elit vestibulum vel. Curabitur in velit a ex consectetur lacinia.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
